<template>
  <div class="receiving-courses" v-show="show || tips">
    <div class="content" v-show="show && !led">
      <h2>领取课程</h2>
      <div class="ps">每人限领一个哦~</div>
      <div class="form">
        <input type="text" placeholder="请输入手机号码" v-model="tel" />
        <div :class="['tip', error[0].status ? 'show' : '']">
          {{ error[0].msg }}
        </div>
        <!-- <div class="img-code" id="gt-box"> -->
          <!-- <input type="text" placeholder="请输入图形码" v-model="captcha">
          <div class="img" @click="resetImgCode">
            <img :src="'https://japi.233.com/ess-ucs-api/basic/do/captcha?captchaKey=' + captchaKey">
          </div> -->
        <!-- </div> -->
        <!-- <div :class="['tip', error[1].status ? 'show' : '']">
          {{ error[1].msg }}
        </div> -->
        <div class="message-code">
          <input
            type="text"
            placeholder="请输入手机验证码"
            v-model="verifycode"
          />
          <div
            :class="['get-code', num > 0 ? 'geting' : '']"
            @click="smsCaptcha"
          >
            {{ num > 0 ? `${num}秒后重新发送` : "获取验证码" }}
          </div>
        </div>
        <div :class="['tip', error[2].status ? 'show' : '']">
          {{ error[2].msg }}
        </div>
        <label class="sublime" @click="LingKe">立即领取</label>
      </div>
    </div>
    <div class="content led" v-show="show && led">
      <p>您已经领取过课程了</p>
      <span @click="toMoreFreeClass">更多免费课程</span>
    </div>
    <div class="close" v-show="show" @click="closeDialog" />
    <div class="tips" v-show="tips">{{ tips }}</div>
  </div>
</template>

<script>
import {
  LoginInfoByPromote,
  LingKeByIsLogin,
  smsCaptcha,
  LingKe,
} from "../../lib/request";
import { initGeetest } from "@/utils";

export default {
  name: "ReceivingCourses",
  props: {
    promoteCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
      tel: null,
      captcha: "",
      verifycode: "",
      verificationImg: {},
      error: [
        {
          status: false,
          msg: "",
        },
        {
          status: false,
          msg: "",
        },
        {
          status: false,
          msg: "",
        },
      ],
      captchaKey: "",
      myclassId: 0,
      tips: "",
      led: false,
      ST: null,
      num: 0,
      // 极验
      validateResult: null,
      captchaObj: null,
    };
  },
  destroyed() {
    this.num = 0;
    clearInterval(this.ST);
  },
  watch: {
    show(v) {
      if (v) {
        this.initGeetest();
      }
    },
  },
  methods: {
    initGeetest() {
      if (this.captchaObj) {
        this.validateResult = null;
        this.captchaObj.reset();
      } else {
        initGeetest(
          {
            nativeButton: {
              width: "300px",
              height: "40px",
            },
            product: "bind",
            hideSuccess: true,
          },
          "gt-box",
          (res) => {
            if (res.type === "ready") {
              this.captchaObj = res.captchaObj;
            } else if (res.type === "success") {
              this.validateResult = res.result;
              this.handlerSendQrcode()
            }
          }
        );
      }
    },
    LoginInfoByPromote(id) {
      this.myclassId = id;
      LoginInfoByPromote({}, (res) => {
        this.loginInfo = res.Result;
        // 是否登录
        if (res.Result.Islogin === 1) {
          // 是否绑定手机号
          if (res.Result.IsbindMobile === 1) {
            this.LingKeByIsLogin();
          } else {
            this.show = true;
            this.resetImgCode();
          }
        } else {
          this.show = true;
          this.resetImgCode();
        }
      });
    },
    // 已登录领课
    LingKeByIsLogin() {
      LingKeByIsLogin(
        {
          promoteCode: this.promoteCode,
          myclassId: this.myclassId,
          url: location.href,
        },
        (res) => {
          if (res.ResultDescription) {
            this.tips = res.ResultDescription;
            setTimeout(() => {
              this.tips = "";
            }, 3000);
          } else {
            const { open, userName, dozDomain } = res.Result;
            if (open === 1) {
              this.tips = "领取成功";
              setTimeout(() => {
                this.tips = "";
                localStorage.setItem(
                  "leadInfo",
                  JSON.stringify({
                    currentUserName: userName,
                    dozDomain,
                    myclassid: this.myclassId,
                  })
                );
                this.$router.push({
                  path: "/success",
                  query: { promoteCode: this.promoteCode },
                });
              }, 2000);
            } else if (res.Result.open === 3) {
              this.show = true;
              this.led = true;
            }
          }
        }
      );
    },
    resetImgCode() {
      this.captchaKey = new Date().getTime();
    },
    // 获取手机验证码
    smsCaptcha() {
      if (!this.tel || (this.tel && this.tel.length === 0)) {
        this.error[0].status = true;
        this.error[0].msg = "请输入手机号码";
        return;
      }
      if (+this.tel.length !== 11 || +this.tel > 19999999999) {
        this.error[0].status = true;
        this.error[0].msg = "请输入正确的手机号码";
        return;
      }
      // if (!this.validateResult) {
      //   this.error[1].status = true;
      //   this.error[1].msg = "请点击按钮进行验证";
      //   return;
      // } else {
      //   this.error[1].status = false;
      // }
      // if (this.captcha.length === 0) {
      //   this.error[1].status = true;
      //   this.error[1].msg = "请输入图形码";
      //   return;
      // }
      // if (this.captcha.length !== 5) {
      //   this.error[1].status = true;
      //   this.error[1].msg = "请输入正确的图形码";
      //   return;
      // }
      if (this.num > 0) {
        return;
      }
      this.error[0].status = false;
      this.captchaObj.showCaptcha();
    },
    handlerSendQrcode() {
      let gtParams = {
        captchaType: 1, // 极验
        geeReq: {
          captchaId: this.validateResult.captcha_id,
          lotNumber: this.validateResult.lot_number,
          captchaOutput: this.validateResult.captcha_output,
          passToken: this.validateResult.pass_token,
          genTime: this.validateResult.gen_time,
        },
      };
      smsCaptcha(
        {
          smsType: "common_captcha",
          tel: this.tel,
          captchaKey: this.captchaKey,
          captcha: this.captcha,
          signName: "网校学习",
          ...gtParams,
        },
        (res) => {
          if (!res.status) {
            this.error[1].status = true;
            this.error[1].msg = res.message;
          } else {
            this.num = 60;
            this.ST = setInterval(() => {
              this.num--;
              console.log(this.num);
              if (this.num === 0) {
                clearInterval(this.ST);
                this.validateResult = null;
                this.captchaObj.reset();
              }
            }, 1000);
            this.error[1].status = false;
          }
        }
      );
    },
    // 未登录领课
    LingKe() {
      if (!this.tel || (this.tel && this.tel.length === 0)) {
        this.error[0].status = true;
        this.error[0].msg = "请输入手机号码";
        return;
      }
      if (+this.tel.length !== 11 || +this.tel > 19999999999) {
        this.error[0].status = true;
        this.error[0].msg = "请输入正确的手机号码";
        return;
      }
      if (this.verifycode.length === 0) {
        this.error[2].status = true;
        this.error[2].msg = "请输入短信验证码";
        return;
      }
      if (this.verifycode.length !== 6) {
        this.error[2].status = true;
        this.error[2].msg = "请输入正确的短信验证码";
        return;
      }
      LingKe(
        {
          promoteCode: this.promoteCode,
          mobile: this.tel,
          verifycode: this.verifycode,
          myclassid: this.myclassId,
          url: location.href,
        },
        (res) => {
          if (res.ResultDescription) {
            this.tips = res.ResultDescription;
            setTimeout(() => {
              this.tips = "";
            }, 3000);
          } else {
            if (res.Result.open === 1) {
              this.tips = "领取成功";
              setTimeout(() => {
                this.tips = "";
                localStorage.setItem("usertoken", res.Result.token);
                localStorage.setItem(
                  "leadInfo",
                  JSON.stringify({ ...res.Result, myclassid: this.myclassId })
                );
                this.$router.push({
                  path: "/success",
                  query: { promoteCode: this.promoteCode },
                });
              }, 2000);
            } else {
              this.tips = "已注册，领取失败";
              setTimeout(() => {
                this.tips = "";
              }, 3000);
            }
          }
        }
      );
    },
    // 更多免费课程
    toMoreFreeClass() {
      location.href =
        location.host === "v.233.com"
          ? "https://v.233.com"
          : location.origin;
    },
    closeDialog() {
      this.show = false;
      this.num = 0;
      clearInterval(this.ST);
    },
  },
};
</script>

<style lang="scss" scoped>
.receiving-courses {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  padding: 0 4%;
  box-sizing: border-box;
  .content {
    background: #fff;
    border-radius: 10px;
    padding: 32px 0 34px;
    max-width: 400px;
    margin: 20% auto 0;
    h2 {
      font-size: 20px;
      color: #333;
      font-weight: 800;
      text-align: center;
      line-height: 20px;
    }
    .ps {
      color: #e13b29;
      font-size: 13px;
      font-weight: 400;
      text-align: center;
      line-height: 13px;
      margin: 8px 0 20px;
    }
    .form {
      margin: 0 auto;
      padding: 0 6%;
      input {
        height: 40px;
        line-height: 40px;
        background: #fff;
        border: 1px solid #cdcdcd;
        border-radius: 5px;
        padding-left: 15px;
        width: 100%;
        box-sizing: border-box;
      }
      .img-code {
        min-width: 300px;
        display: flex;
        justify-content: space-between;
        input {
          width: calc(100% - 110px);
        }
        .img {
          border: 1px solid #cdcdcd;
          border-radius: 5px;
          display: inline-block;
          width: 100px;
          min-width: 100px;
          height: 40px;
          cursor: pointer;
          img {
            width: 100%;
            height: 40px;
          }
        }
      }
      .message-code {
        display: flex;
        justify-content: space-between;
        input {
          width: calc(100% - 110px);
        }
        .get-code {
          border: 1px solid #e13b29;
          border-radius: 5px;
          display: inline-block;
          width: 100px;
          min-width: 100px;
          height: 40px;
          color: #e13b29;
          font-size: 13px;
          font-weight: 400;
          line-height: 38px;
          text-align: center;
          background: #fff1ef;
          box-sizing: border-box;
          cursor: pointer;
        }
        .geting {
          border: 1px solid #f5f5f5;
          color: #999;
          background: #f5f5f5;
        }
      }
      .tip {
        font-size: 12px;
        color: #e13b29;
        font-weight: 400;
        line-height: 12px;
        margin: 6px 0 12px 15px;
        opacity: 0;
        height: 12px;
      }
      .show {
        opacity: 1;
      }
      .sublime {
        margin-top: 10px;
        font-size: 17px;
        color: #fff;
        font-weight: 800;
        display: inline-block;
        width: 100%;
        height: 45px;
        line-height: 45px;
        background: linear-gradient(45deg, #e63025 0%, #ff5739 100%);
        border-radius: 23px;
        text-align: center;
        box-shadow: 0px 9px 19px #f03f2d57;
        cursor: pointer;
      }
    }
  }
  .led {
    text-align: center;
    padding: 50px 27px 34px;
    p {
      color: #333;
      font-size: 17px;
      line-height: 17px;
    }
    span {
      margin-top: 30px;
      display: inline-block;
      cursor: pointer;
      width: 100%;
      height: 45px;
      line-height: 45px;
      color: #fff;
      font-size: 17px;
      font-weight: 800;
      text-align: center;
      background: linear-gradient(45deg, #e63025 0%, #ff5739 100%);
      border-radius: 23px;
    }
  }
  .close {
    width: 40px;
    height: 40px;
    margin: 10% auto 0;
    background: url("https://img2.233.com/wx/union/wap/leadaclass/close-icon.png")
      no-repeat;
    background-size: 100%;
    cursor: pointer;
  }
  .tips {
    position: fixed;
    z-index: 222;
    top: 50%;
    left: 50%;
    margin-left: -111px;
    width: 222px;
    text-align: center;
    padding: 20px 36px;
    box-sizing: border-box;
    color: #fff;
    font-weight: 400;
    font-size: 15px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 10px;
    margin-top: -30px;
  }
}
</style>
